interface Props {
    children: React.ReactNode
}

export function ListSideNews({ children }: Props) {
    return (
        <div className="col-span-1 lg:col-span-5 flex flex-col gap-6 h-full">
            {children}
        </div>
    )
}